















import { forEach } from "lodash";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Prop, Watch } from "vue-property-decorator";
@Component({
})
export default class MultiSelectComponent extends Vue {
    @Prop() items;
    @Prop() lable;
    @Prop() modelKey;
    @Prop() disabled;
    @Prop() data;
    @Prop() context;
    @Prop() rules;
    componentData=[];

    update()
    {
      let transformedData=JSON.stringify(this.componentData);
      this.data[this.modelKey]=""
      this.data[this.modelKey]=transformedData;
    }

    @Watch("items")
    onChange(value)
    {
      if(this.context=='update' && this.componentData.length==0)
      {
        let transformedData=JSON.parse(this.data[this.modelKey]);
        this.componentData=transformedData;
        this.data[this.modelKey]=JSON.stringify(transformedData);
      }
      else
      {
        this.componentData=[]
        this.items.forEach(element => {
          this.componentData.push(element.Value)
        });
        let transformedData=JSON.stringify(this.componentData);
        this.data[this.modelKey]=""
        this.data[this.modelKey]=transformedData;
      }
    }
}
